import { useParams } from 'react-router-dom'

import { useMainContext } from '../../../../../core/contexts/main'
import DetailsLayout from '../../../../layout/main/DetailsLayout'
import { DetailRow, LeftHeadDecoration, RightHeadDecoration } from '../../../../../styles/main/MainCommonStyles'
import { DText, Flex } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import { formatDate } from '../../../../../core/utils/common'
import { useGetARecipients } from '../../../../../core/services/react-query/report/due-payments'
import UserLink from '../../../../common/utils/UserLink'

const RecipientDetails = ({ detailId }) => {
    const params = useParams()
    const { lang } = useMainContext()

    const {
        data: recipient,
        isFetching,
        isError
    } = useGetARecipients(detailId || params.detailId)

    const fullName =
        recipient?.details
            ? `${recipient.details.firstName || ''} ${recipient.details.lastName || ''}`
            : recipient?.meta?.label || ''

    const detailsRows = parseRecipientDetails(recipient)

    return (
        <DetailsLayout
            isFetching={isFetching}
            isError={isError}
            type={recipient?.meta?.isValid ? 'VALID' : 'INVALID'}
        >
            <LeftHeadDecoration left={'10px'}>
                <DText main>{recipient?.refId}</DText>
            </LeftHeadDecoration>
            <RightHeadDecoration right="10px">
                <DText main className='text-nowrap'><Text tid="recipient-details" /></DText>

            </RightHeadDecoration>

            <DetailRow>
                <DText main><Text tid="user" /></DText>
                <Flex justify={'flex-end'}>
                    <UserLink
                        _id={recipient?.userId}
                        name={recipient?.userId}
                    />
                </Flex>
            </DetailRow>

            {detailsRows.map((item) => (
                <DetailRow key={item.key}>
                    <DText main>{item.key}</DText>
                    <Flex justify={'flex-end'}>
                        <DText primary lineBreak="anywhere">
                            {item.value}
                        </DText>
                    </Flex>
                </DetailRow>
            ))}

            {/* CREATED AT */}
            <Flex fw justify={'space-between'} style={{ marginTop: '20px' }}>
                <DText main>
                    {formatDate(recipient?.createdAt, 'date', lang)}
                </DText>
                <DText main>
                    {formatDate(recipient?.createdAt, 'time', lang)}
                </DText>
            </Flex>
        </DetailsLayout>
    )
}

export default RecipientDetails


// recipientDetails.parser.ts

export const parseRecipientDetails = (recipient) => {
    if (!recipient?.details) return []

    const details = recipient.details

    return Object.entries(details)
        .map(([key, value]) => {
            // handle nested objects (like beneficiaryAddress)
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                return Object.entries(value).map(([nestedKey, nestedValue]) => ({
                    key: `${key}.${nestedKey}`,
                    value: normalizeValue(nestedValue),
                }))
            }

            return {
                key,
                value: normalizeValue(value),
            }
        })
        .flat()
}

const normalizeValue = (value) => {
    if (value === null || value === undefined || value === '') return '-'

    if (typeof value === 'boolean') return value ? 'YES' : 'NO'

    if (typeof value === 'string' || typeof value === 'number')
        return value

    if (Array.isArray(value)) return value.join(', ')

    return JSON.stringify(value)
}